/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ profile: NonNullable<unknown> }} Task_Settings_Remove_ProfileInputs */

const en_task_settings_remove_profile = /** @type {(inputs: Task_Settings_Remove_ProfileInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Remove ${i?.profile}`)
};

const pt_br2_task_settings_remove_profile = /** @type {(inputs: Task_Settings_Remove_ProfileInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Remover ${i?.profile}`)
};

/**
* | output |
* | --- |
* | "Remove {profile}" |
*
* @param {Task_Settings_Remove_ProfileInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_settings_remove_profile = /** @type {((inputs: Task_Settings_Remove_ProfileInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Settings_Remove_ProfileInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_settings_remove_profile(inputs)
	return pt_br2_task_settings_remove_profile(inputs)
});